module.exports = __webpack_public_path__ + "static/2-7a71744794483cfd11149d0e9e95ab84.png";